import React from 'react';
import styled from 'styled-components';

import { Close } from '@lt/components/icons-react';
import { Image } from '@lt/components';
import type { TourGuideButtonProps } from '../../../types';
import { container } from '../style';
import styles from '../TourGuideButton.module.css';

export const TourGuideButton = (props: TourGuideButtonProps): JSX.Element => {
  const {
    onClick,
    onClose,
    className,
    text,
    description,
    isCheckoutPage,
    bannerImage,
  } = props;
  return (
    <Container
      onClick={onClick}
      className={className}
      $isCheckoutPage={isCheckoutPage}
    >
      <TextContainer>
        <Text>{text}</Text>
        <Description>{description}</Description>
      </TextContainer>
      <ImageWrapper>
        <Image src={bannerImage} fallback="" className={styles.image} />
      </ImageWrapper>
      <CloseIcon onClick={onClose} />
    </Container>
  );
};

const Container = styled.div<{ $isCheckoutPage?: boolean }>`
  ${container}
  background-color:${({ $isCheckoutPage }) =>
    $isCheckoutPage ? ' #F3F3F3;' : ' #FFFFFF;'}
  height: 72px;
  border-radius: 8px;
  justify-content: space-between;
`;

const Text = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  float: left;
`;

const ImageWrapper = styled.div`
  width: 72px;
  height: 72px;
  float: right;
  margin-right: 20px;
`;

const CloseIcon = styled(Close)`
  width: 12px;
  height: 12px;
  position: absolute;
  top: 8px;
  right: 8px;
  & path {
    stroke: #000000;
  }
`;
